<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <wt-form-table :form.sync="form" @on-button-action="onButtonAction"  >
        <wt-form-table-list ref="firstFormTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
          <template slot="totalWeight" slot-scope="data">
            <span>{{ $wtUtil.transWeight(data.row.totalWeight) }}</span>
          </template>
        </wt-form-table-list>
      </wt-form-table>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'IntegralRankingView',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_USERINTEGRALDETAILS',
      isSubmitLoading: false,
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_USERINTEGRALDETAILS',
        formComponent: {
          view: { type: 'component', componentName: 'UserIntegralDetails-view', value: 'queryUserIntegralDetailsDetailData' },
          add: { type: 'component', componentName: 'UserIntegralDetails-edit', value: 'resetUserIntegralDetailsDetailData' },
          edit: { type: 'component', componentName: 'UserIntegralDetails-edit', value: 'queryUserIntegralDetailsDetailData' },
          list: { type: 'default', value: '/modules/userIntegralDetails/communityUserIntegralRanking' },
          delete: { type: 'default', value: '/modules/userIntegralDetails/userIntegralDetailsDelete' }
        },
        formInputsData: [{ name: '搜索用户', key: 'id', value: '', type: 'customAll' },
          { name: '搜索用户', key: 'keyWord', value: '', type: 'text' },
          { name: '创建时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [],
        formTableData: [
          { name: '排名', key: 'rank', type: 'text' },
          { name: '昵称', key: 'nickName', type: 'text' },
          { name: '手机号码', key: 'phone', type: 'text' },
          { name: '投递重量(kg)', key: 'totalWeight', type: 'custom' },
          { name: '创建时间', key: 'createTime', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      }
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '社区内用户排行榜' }})
    this.form.formInputsData[0].value = this.detailFormData.id
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      }
    },
    onButtonAction() {

    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.userIntegralDetails.userIntegralDetailsDetailData
    })
  }
}
</script>

<style scoped>

</style>
